module.exports = __webpack_public_path__ + "img/Title_KOVAX1.be28aad7.png";